import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import { useEffect, useState } from "react";
import Offers from "./pages/Offers";
import Contact from "./pages/Contact";

import Layout from "./components/Layout";

import DetailPage from "./pages/DetailPage";
import OfferDetail from "./pages/OfferDetail";

import { Routes, Route, Link, Navigate } from "react-router-dom";

import Main from "./pages/Main";
import { useLocation } from "react-router-dom";

import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import ProjectDetail from "./components/ProjectDetail";
import ProjectsGrid, {
  ProjectsGrid as NamedProjectsGrid,
} from "./components/ProjectsGrid";
import SimpleBlogPost from "./components/SimpleBlogPost";
import ScrollRestoration from "./components/ScrollRestoration";
import TestBlogCarousel from "./pages/TestBlogCarousel";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [codeword, setCodeword] = useState("");
  const correctCodeword = "porsche911"; // Replace with your actual codeword

  const handleContactButton = () => {
  };

  const location = useLocation();

  // Enable browser scroll restoration for back/forward navigation
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "auto";
    }
  }, []);

  // Track navigation type to preserve scroll position on back/forward
  useEffect(() => {
    // Create a navigation entry listener to detect back/forward navigation
    const handlePopState = () => {
      // Don't scroll to top on back/forward navigation
      // The browser will handle scroll restoration automatically
    };

    window.addEventListener("popstate", handlePopState);

    // For programmatic navigation (Link clicks), scroll to top
    const isBackForwardNavigation = window.history.state?.isBackForward;
    if (!isBackForwardNavigation) {
      window.scrollTo(0, 0);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname]);

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        const navbarHeight = 90; // Approximate navbar height
        const elementPosition = targetElement.offsetTop - navbarHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: "auto",
        });
      }
    }
  }, [location.hash]);

  const handleLogin = () => {
    if (codeword === correctCodeword) {
      setIsAuthenticated(true);
    } else {
      alert("Incorrect codeword!");
    }
  };
  if (false) {
    // if (!isAuthenticated) {
    // block website for maintenance

    return (
      <div className="login-container">
        <h2>Diese Website befindet sich im Aufbau.</h2>
        <input
          type="text"
          value={codeword}
          onChange={(e) => setCodeword(e.target.value)}
          placeholder="Passwort"
        />
        <button onClick={handleLogin}>Zugang</button>
      </div>
    );
  }

  return (
    <div>
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Main />} />

          <Route path="/motorenbau/:slug" element={<DetailPage />} />
          <Route
            path="/motorenbau"
            element={
              <Navigate to="/motorenbau/leistungssteigerungen" replace />
            }
          />
          <Route path="/restauration" element={<DetailPage />} />
          <Route path="/leistungssteigerungen" element={<DetailPage />} />
          <Route path="/motorsport" element={<DetailPage />} />
          <Route path="/service-wartung" element={<DetailPage />} />
          <Route path="/porsche-elektronik" element={<DetailPage />} />
          <Route path="/porsche-reparatur" element={<DetailPage />} />
          <Route path="/porsche-gutachten" element={<DetailPage />} />
          <Route path="/porsche-verkaufen" element={<DetailPage />} />
          <Route path="/aktuelle-angebote" element={<Offers />} />
          <Route path="/aktuelle-angebote/:id" element={<OfferDetail />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />

          {/* Blog routes */}
          <Route path="/blog/:slug" element={<SimpleBlogPost />} />

          <Route path="/projekte/:id" element={<ProjectDetail />} />
          <Route
            path="/projekte"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          {/* Related articles routes */}
          <Route
            path="/motorenbau/:parentSlug/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/restauration/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/leistungssteigerungen/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/motorsport/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/service-wartung/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/porsche-elektronik/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/porsche-reparatur/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/porsche-gutachten/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          <Route
            path="/porsche-verkaufen/verwandte-artikel/:id"
            element={<ProjectDetail />}
          />
          {/* Related articles listing pages */}
          <Route
            path="/motorenbau/:parentSlug/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/restauration/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/leistungssteigerungen/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/motorsport/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/service-wartung/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/porsche-elektronik/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/porsche-reparatur/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/porsche-gutachten/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
          <Route
            path="/porsche-verkaufen/verwandte-artikel"
            element={<ProjectsGrid showAll={true} showIntro={false} />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
